import { ReduxSagaRequest } from "@hlibs/index";
import * as Requests from "./requests";

class Advertiser extends ReduxSagaRequest {
  static create = (name, funcAsync = null, funcResult = null) =>
    new Advertiser(name, funcAsync, funcResult);
  get advertiser() {
    return super.getState("advertiser");
  }
  list(callback = null) {
    super.request({ type: "List", callback });
  }
  add(name, code, callback = null) {
    super.request({ type: "Add", params: { name, code }, callback });
  }
  update(name, code, callback = null) {
    super.request({ type: "Update", params: { name, code }, callback });
  }
  info(code, callback = null) {
    super.request({ type: "Info", params: { code }, callback });
  }
}

const reduxModule = Advertiser.create("Advertiser", async (payload) => {
  switch (payload.type) {
    case "List":
      return await Requests.List(payload.callback, reduxModule);
    case "Add":
      return await Requests.Add(payload.params, payload.callback, reduxModule);
    case "Info":
      return await Requests.Info(payload.params, payload.callback, reduxModule);
    case "Update":
      return await Requests.Update(
        payload.params,
        payload.callback,
        reduxModule
      );
    default:
      return null;
  }
});

export default reduxModule;
